const initState = {
    autorizar_List: null,
    autorizar_Detalle: null,
    autorizar_Resolver: null,
    autorizar_Guia: null,
    autorizar_Error_Message: null,
}

const autorizarReducer = (state = initState, action) => {
    switch (action.type) {
        case "AUTORIZAR_LIST_SUCCESS":
            return {
                ...state,
                autorizar_List: action.payload.data,
                autorizar_Error_Message: null,
            }
        case "AUTORIZAR_DETALLE_SUCCESS":
            return {
                ...state,
                autorizar_Detalle: action.payload.data,
                autorizar_Error_Message: null,
            }
        case "AUTORIZAR_RESOLVER_SUCCESS":
            return {
                ...state,
                autorizar_Resolver: action.payload.data,
                autorizar_Error_Message: null,
            }
        case "AUTORIZAR_GUIA_SUCCESS":
            return {
                ...state,
                autorizar_Guia: action.payload.data,
                autorizar_Error_Message: null,
            }
        case "AUTORIZAR_LIMPIAR_DETALLE":
            return {
                ...state,
                autorizar_Detalle: null,
            }
        case "AUTORIZAR_LIMPIAR_RESOLVER":
            return {
                ...state,
                autorizar_Resolver: null,
            }
        case "AUTORIZAR_LIMPIAR_GUIA":
            return {
                ...state,
                autorizar_Guia: null,
            }
        case "AUTORIZAR_ERROR":
            // No tumba los datos ya cargados: un error del resolver o de una
            // carga puntual solo muestra el mensaje (patron de las otras vistas).
            return {
                ...state,
                autorizar_Error_Message: action.payload.error,
            }
        case "AUTORIZAR_CLOSE_MESSAGES":
            return {
                ...state,
                autorizar_Error_Message: null,
            }
        default:
            return state;
    }
};

export default autorizarReducer;
